import supabase from '../supabaseClient'
import { TABLE_NAMES } from '../config'
import { isCoach } from './signupFunnelRedirect'

/**
 * Returns membership info when the user is already a coach at an academy
 * (Users.academy_id is set and coach flag is true). Otherwise null.
 */
export async function fetchExistingAcademyMembership(userId) {
  if (!userId) return null

  const { data: userProfile, error: profileError } = await supabase
    .from(TABLE_NAMES.USERS)
    .select('academy_id, coach')
    .eq('user_id', userId)
    .maybeSingle()

  if (profileError || !userProfile?.academy_id || !isCoach(userProfile)) {
    return null
  }

  const { data: academyData } = await supabase
    .from(TABLE_NAMES.ACADEMIES)
    .select('name')
    .eq('id', userProfile.academy_id)
    .maybeSingle()

  const academyName = academyData?.name || null

  return {
    academyId: userProfile.academy_id,
    academyName: academyName || 'your academy',
  }
}

/**
 * Allow the academy coach signup funnel only when the user is not already
 * a coach at an academy.
 */
export function shouldAllowAcademySignupFlow(academyId, coachFlag) {
  if (!academyId) return true
  return !isCoach({ coach: coachFlag })
}

export function academyLoginRedirectState(academyName) {
  return { alreadyInAcademy: academyName || 'your academy' }
}
